var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-list"},[_vm._l((_vm.navList),function(item,index){return _c('NavLink',{key:index,attrs:{"nav":item},on:{"click":function($event){return _vm.handleClickNav(index, item.text)}}})}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }